export type FilterItem = {
  id: string;
  label: string;
  count: number;
};

export const DEFAULT_FILTERS: FilterItem[] = [
  { id: 'a', label: 'API', count: 12 },
  { id: 'b', label: 'UI', count: 8 },
  { id: 'c', label: 'Data', count: 5 },
  { id: 'd', label: 'Infra', count: 3 },
  { id: 'e', label: 'Research', count: 2 },
  { id: 'f', label: 'Design', count: 6 },
];
